<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-2xl p-6 m-4 max-w-sm w-full text-center">
        <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto m-4"><svg
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-check w-8 h-8 text-green-600">
                    <path d="M20 6 9 17l-5-5"></path>
                </svg></div>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
            保存完了
        </h3>
        <p class="text-gray-600">
            {{message}}
        </p>
    </div>
</div>